import { render, staticRenderFns } from "./MeasureTypeSelect.vue?vue&type=template&id=c4810d34&"
import script from "./MeasureTypeSelect.vue?vue&type=script&lang=ts&"
export * from "./MeasureTypeSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports